<template>
  <div>
    <b-card header-tag="nav" v-if="ready">
      <b-card-text>
        <h6 class="tw-font-bolder tw-mb-0">HLC Enrollment</h6>
        <p class="text-secondary tw-text-xs">Percentage of HLC Clusters Meeting Target Compound Enrollment</p>

        <doughnut-chart class="shift-pills" :chartdata="totalChartdata" :options="options"></doughnut-chart>
        <div id="followup-label">
          <h1 class="tw-text-4xl tw-font-bolder text-center tw-mb-0">{{ percent }}%</h1>
          <h5 class="tw-font-bolder text-center">Target Reached</h5>
        </div>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

// import {
//     mapState, mapGetters, mapActions
// } from 'vuex';

import DoughnutChart from "@/components/charts/DoughnutChart.vue";

export default {
  mixins: [],
  components: {
    DoughnutChart
  },
  props: {},
  data: function() {
    return {
      ready: false,
      data: null,
      percent: 0,
      totalChartdata: {
        datasets: [
        ],
        labels: ["Target Reached", "Under Target"]
      },
      compoundChartdata: {
        datasets: [
          {
            data: [],
            backgroundColor: ["#37B1CA", "#a3d2e0", "#d9eaef"]
          }
        ],
        labels: ["Complete", "Late", "Missed"]
      },
      clinicChartdata: {
        datasets: [
        ],
        labels: ["Complete", "Late", "Missed"]
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        cutoutPercentage: 65,
        circumference: Math.PI,
        rotation: -Math.PI,
        legend: {
          position: "bottom",
          labels: {
            boxWidth: 18
          }
        },
        title: {
          display: false,
          text: "Enrolled Subjects"
        },
        tooltips: {
          bodyFontSize: 14
        },
        animation: {
          animateScale: true,
          animateRotate: true
        }
      }
    };
  },
  computed: {
    // ...mapState('sample', ['sample'])
  },
  created: function() {},
  mounted: function() {
    this.get();
  },
  methods: {
    get: function() {
      const that = this;
      HTTP.get("/kenya/metrics/followups-completed")
        .then(response => {
          that.ready = false;
          that.data = response.data;

          that.totalChartdata.datasets.push({
            data: that.data['total'],
            backgroundColor: ["#37B1CA", "#a3d2e0", "#d9eaef"]
          });
          that.clinicChartdata.datasets.push({
            data: that.data['clinic'],
            backgroundColor: ["#37B1CA", "#a3d2e0", "#d9eaef"]
          });
          that.compoundChartdata.datasets.push({
            data: that.data['compound'],
            backgroundColor: ["#37B1CA", "#a3d2e0", "#d9eaef"]
          });

          that.setData("total");
        })
        .catch(error => {
          HandleErrors.HandleErrors(error);
        });
    },
    setData: function(view) {
      let that = this;
      that.view = view;

      that.percent = Math.round(
        (that.data[view][0] / (that.data[view][0] + that.data[view][1] + that.data[view][2])) * 100
      );

      that.ready = true;
    },
    find: function() {},
    create: function() {},
    patch: function() {},
    update: function() {},
    delete: function() {}
  }
};
</script>

<style>
#followup-label {
  position: absolute;
  top: 70%;
  left: 50%;
  transform: translate(-50%, -50%);
}
nav.card-header {
  border-bottom: none;
  padding: 0.5rem 0 0 0;
}
ul.nav.nav-tabs {
  padding: 0 .5rem;
}
ul.nav.nav-tabs li.nav-item {
  font-size: 0.7rem;
}
ul.nav.nav-tabs a.nav-link {
  padding: .35rem .5rem;
}
ul.nav.nav-pills {
  margin-top: 25px;
}
ul.nav.nav-pills a.nav-link {
  color: #18487c;
  padding: .25rem .5rem;
}
ul.nav.nav-pills a.nav-link.active {
  color: #fff;
  background-color: #18487c;
}
.shift-pills {
  margin-top: -42px;
}
</style>